import styled from 'styled-components';
import { Column } from '../../UI';

export const StyledColumn = styled(Column)`
    padding: 10px 0;
`;
